<template>
  <ul v-if="hasItems" class="list-cell uk-list" :class="listCss">
    <li v-for="item in items">
      <slot name="item" :item="item">{{item}}</slot>
    </li>
  </ul>
  <text-placeholder v-else class="list-cell--empty" />
</template>

<script>
import TextPlaceholder from '@/components/TextPlaceholder';

export default {
  name: 'list-cell',
  components: {
    TextPlaceholder,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    type: String,
  },
  computed: {
    hasItems() {
      return this.items && this.items.length > 0;
    },
    listCss() {
      return {
        [`uk-list-${this.type}`]: !!this.type,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// ListCell.vue?c523bbca